
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import sound from "../../../images/alaram.mp3";
const Orders = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [expandedOrder, setExpandedOrder] = useState(null);
    const [orders, setOrders] = useState([]);
    const [checkedItems, setCheckedItems] = useState({});
    const [vendorId, setVendorId] = useState(null);

    const scrollContainerRef = useRef(null);
    const [showTableDetails, setShowTableDetails] = useState({}); // ✅ track dine-in detail toggles

    const [showExpanded, setShowExpanded] = useState({}); // <-- added for Table Info toggle
    const notificationSound = new Audio(sound);
    // ✅ Toggle handler for Table Info

    const handleCheckboxChange = (listId) => {
        setCheckedItems((prev) => ({
            ...prev,
            [listId]: !prev[listId],
        }));
        console.log("Selected List ID:", listId);
    };


    const handleCancelSingleOrder = async (listId) => {
        try {
            const token = localStorage.getItem("authToken"); // ✅ Adjust key name if needed

            if (!token) {
                alert("Authorization token not found!");
                return;
            }

            const response = await fetch(
                `https://backend.maamaas.com/food/orderscancellationlist/edit/${listId}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`, // 👈 Add token here
                    },
                    body: JSON.stringify({
                        status: "Cancelled",
                    }),
                }
            );

            if (!response.ok) {
                console.error(`Failed to cancel order ${listId}`);
                alert(`Failed to cancel order ${listId}`);
            } else {
                console.log(`Order ${listId} cancelled successfully.`);
                alert(`Order ${listId} has been cancelled.`);
                // Optional: Uncheck after cancellation
                setCheckedItems((prev) => {
                    const updated = { ...prev };
                    delete updated[listId];
                    return updated;
                });
            }
        } catch (error) {
            console.error("Error cancelling order:", error);
        }
    };
    const handleToggleTableDetails = (uniqueId) => {
        setShowExpanded((prev) => ({
            ...prev,
            [uniqueId]: !prev[uniqueId], // toggle only this card
        }));
    };


    const handleOrderClick = (order) => {
        const id = order.orderId || order.cartId; // normalize ID
        console.log("Clicked order:", order); // ✅ debug

        if (expandedOrder && expandedOrder.id === id) {
            console.log("Collapsing order:", id);
            setExpandedOrder(null); // collapse
        } else {
            console.log("Expanding order:", id);
            setExpandedOrder({ ...order, id }); // expand
        }
    };






    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        setVendorId(storedVendorId);
    }, []);


    const [acceptedItems, setAcceptedItems] = useState({});

    const [selectedItems, setSelectedItems] = useState({});

    // Toggle checkbox
    const handleCheckboxChangea = (itemId) => {
        setSelectedItems((prev) => ({
            ...prev,
            [itemId]: !prev[itemId],
        }));
    };

    // Accept selected items
    const handleAcceptOrderrsss = async (e, cartId) => {
        e.stopPropagation();

        const status = "PROCESSING";
        const note = "sds";

        // Get array of selected itemIds
        const itemIds = Object.keys(selectedItems).filter((id) => selectedItems[id]);

        if (itemIds.length === 0) {
            alert("Please select at least one item to accept.");
            return;
        }

        const url = `https://backend.maamaas.com/food/api/cart/cart/status/${cartId}?itemIds=${itemIds.join(
            "&itemIds="
        )}&status=${status}&note=${encodeURIComponent(note)}`;

        try {
            const response = await fetch(url, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
            });

            if (!response.ok) throw new Error(`Error: ${response.status}`);

            const data = await response.json();
            console.log("✅ Status updated:", data);
            // alert("Items accepted successfully!");

            // Optional: clear selections
            setSelectedItems({});
        } catch (error) {
            console.error("❌ Failed to update status:", error);
            alert("Failed to update item status. Please try again.");
        }
    };







    const handleAcceptOrderrs = async (e, itemId) => {
        e.stopPropagation();

        const status = "PROCESSING";
        const note = "sds"; // optional note
        const url = `https://backend.maamaas.com/food/api/cart/cartitem/status/${itemId}?status=${status}&note=${encodeURIComponent(note)}`;

        try {
            const response = await fetch(url, {
                method: "PUT", // or POST depending on your API
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                throw new Error(`Error: ${response.status}`);
            }

            const data = await response.json();
            console.log("✅ Status updated:", data);

            // Optional: update local state so UI reflects change
            // e.g., remove item from list or update its status
        } catch (error) {
            console.error("❌ Failed to update status:", error);
        }
    };

    const handleAcceptOrderrss = async (e, itemId) => {
        e.stopPropagation();

        const status = "CANCELLED";
        const note = "sds"; // optional note 
        const url = `https://backend.maamaas.com/food/api/cart/cartitem/status/${itemId}?status=${status}&note=${encodeURIComponent(note)}`;

        try {
            const response = await fetch(url, {
                method: "PUT", // or POST depending on your API
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                throw new Error(`Error: ${response.status}`);
            }

            const data = await response.json();
            console.log("✅ Status updated:", data);

            // Optional: update local state so UI reflects change
            // e.g., remove item from list or update its status
        } catch (error) {
            console.error("❌ Failed to update status:", error);
        }
    };

    // Define fetchOrders outside useEffect so it can be called after accepting
    const fetchOrders = async () => {
        if (!vendorId) return;

        const token = localStorage.getItem("authToken");
        if (!token) return;

        try {
            const vendorRes = await axios.get(
                `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            const filteredVendorOrders = vendorRes.data.filter(
                (order) => !(order.orderType === "TABLE_DINE_IN" && order.status === "PENDING")
            );
            // 3️⃣ Separate pending and confirmed orders
            const pendingOrders = filteredVendorOrders.filter((order) => order.status === "PENDING");


            const confirmedOrdersFromVendor = vendorRes.data.filter(
                (order) =>
                    Array.isArray(order.cartItems) &&
                    order.cartItems.some((item) => item.orderStatus === "CONFIRMED")
            );

            // Fetch TABLE_DINE_IN orders all the data not founded in the catering of the paritcular data 
            const statuses = ["PENDING", "CONFIRMED"];
            const dineInPromises = statuses.map((status) =>
                axios.get(
                    `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/${status}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                )
            );

            const dineInResponses = await Promise.all(dineInPromises);
            const dineInOrders = dineInResponses.flatMap((res) => res.data || []);

            // Merge all results
            const allOrders = [...pendingOrders, ...confirmedOrdersFromVendor, ...dineInOrders];

            // Deduplicate
            const uniqueOrders = allOrders.filter(
                (order, index, self) =>
                    index ===
                    self.findIndex(
                        (o) =>
                            (o.cartId && o.cartId === order.cartId) ||
                            (o.orderId && o.orderId === order.orderId)
                    )
            );

            // 🔔 Check for new orders
            const previousOrdersIds = orders.map((o) => o.orderId || o.cartId);
            const newOrders = uniqueOrders.filter(
                (o) => !previousOrdersIds.includes(o.orderId || o.cartId)
            );

            if (newOrders.length > 0) {
                notificationSound.play().catch((e) => console.warn("Autoplay prevented:", e));
            }

            setOrders(uniqueOrders);
        } catch (error) {
            console.error("Error fetching orders:", error.response?.data || error.message);
        }
    };



    useEffect(() => {
        fetchOrders();
        const intervalId = setInterval(fetchOrders, 1000); // Refresh every 1 second
        return () => clearInterval(intervalId);
    }, [vendorId]);


    // 👈 watch vendorId changes

    // Auto-scroll logic
    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;

        let interval;

        const startScrolling = () => {
            interval = setInterval(() => {
                if (!isHovered) {
                    scrollContainer.scrollTop += 1;

                    if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
                        scrollContainer.scrollTop = 0;
                    }
                }
            }, 20);
        };

        startScrolling();

        return () => clearInterval(interval);
    }, [isHovered]);

    const getOrderColor = (orderType) => {
        const normalized = (orderType || "").trim().toLowerCase();
        switch (normalized) {
            case "dine_in":
                return "#1E90FF";
            case "takeaway":
                return "#FF6347";
            case "delivery":
                return "#20B2AA";
            case "table_dine_in":
                return "#2051b2ff";
            default:
                return "#ccc";
        }
    };


    // Accept button handler
    const handleAcceptOrderr = async (e, orderId) => {
        e.stopPropagation();

        const token = localStorage.getItem("authToken"); // ✅ Retrieve token
        if (!token) {
            alert("Authentication token is missing.");
            return;
        }

        try {
            const response = await axios.put(
                `https://backend.maamaas.com/food/api/orders/edit-orders/${orderId}/CONFIRMED`,
                {
                    status: "CONFIRMED", // send in body
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`, // ✅ Add token to headers
                    },
                }
            );

            console.log("Status updated:", response.data);

            // Update local UI
            setOrders((prev) => prev.filter((order) => order.orderId !== orderId));
        } catch (error) {
            console.error("Failed to update order status:", error.response?.data || error.message);
        }
    };


    const handleDeclineOrder = async (e, orderId) => {
        e.stopPropagation();

        const token = localStorage.getItem("authToken"); // ✅ Retrieve token /api/orders/cancal/total/order/{orderId}
        if (!token) {
            alert("Authentication token is missing.");
            return;
        }

        try {
            const response = await axios.put(
                `https://backend.maamaas.com/food/api/orders/cancal/total/order/${orderId}`,

                {
                    headers: {
                        Authorization: `Bearer ${token}`, // ✅ Add token to headers
                    },
                }
            );

            console.log("Status updated:", response.data);

            // Update local UI
            setOrders((prev) => prev.filter((order) => order.orderId !== orderId));
        } catch (error) {
            console.error("Failed to update order status:", error.response?.data || error.message);
        }
    };


    return (
        <div
            style={{
                position: "fixed",
                bottom: "20px",
                right: "16px",
                height: "595px",
                borderRadius: "8px",
                padding: "10px",
            }}
            className="scroll-fixed-data mobilescroll"
        >
            <div
                style={{
                    maxHeight: "570px",
                    overflowY: "auto",
                    paddingRight: "5px",
                    scrollbarWidth: "none",
                    msOverflowStyle: "none",
                    marginTop: "30px",
                }}
                className="hide-scrollbar"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                {orders.map((order, index) => {
                    const uniqueId = order.orderId || order.cartId;
                    const itemsList = order.items || order.order || order.cartItems || [];

                    const isExpanded =
                        expandedOrder &&
                        (expandedOrder.orderId === uniqueId || expandedOrder.cartId === uniqueId);

                    return (
                        <div
                            key={`${uniqueId}-${index}`}
                            onClick={() => handleOrderClick(order)}
                            className="card scroll-data-responsive"
                            style={{
                                cursor: "pointer",
                                width: "300px",
                                marginBottom: "10px",
                                background: getOrderColor(order.orderType),
                                borderRadius: "8px",
                                boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
                                padding: "10px",
                                position: "relative",
                                transition: "all 0.3s ease",
                                height: isExpanded ? "auto" : "120px",
                            }}
                        >
                            <div style={{ width: "100%" }}>
                                {/* Header */}
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        color: "#fff",
                                        fontWeight: "bold",
                                    }}
                                >
                                    <p>Order ID: #{uniqueId}</p>
                                    <h5 style={{ marginTop: "-15px" }}>{order.orderType || "N/A"}</h5>
                                </div>




                                {isExpanded && (
                                    <div style={{ marginTop: "-10px" }}>
                                        <h6 style={{ color: "#fff", fontSize: "20px" }}>Items:</h6>

                                        {/* For TABLE_DINE_IN orders */}
                                        {order.orderType === "TABLE_DINE_IN" && (
                                            <ul
                                                style={{
                                                    listStyle: "none",
                                                    padding: 0,
                                                    marginLeft: "10px",
                                                    fontWeight: "bold",
                                                }}
                                                onClick={(e) => e.stopPropagation()} // ✅ stop collapse when clicking anywhere inside
                                            >
                                                {itemsList.map((item, idx) => (
                                                    <li
                                                        key={idx}
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                            color: "#000",
                                                            fontSize: "18px",
                                                            marginBottom: "10px",
                                                            padding: "6px 10px",
                                                        }}
                                                    >
                                                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={!!selectedItems[item.itemId]}
                                                                onChange={(e) => {
                                                                    e.stopPropagation(); // ✅ prevent collapse
                                                                    handleCheckboxChangea(item.itemId);
                                                                }}
                                                            />
                                                            <span style={{ fontWeight: "600" }}>
                                                                {item.dishName || "Unnamed Dish"} × {item.updateQuantity ?? 0}
                                                            </span>
                                                        </div>

                                                        {/* <div style={{ display: "flex", gap: "8px" }}>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation(); // ✅ prevent collapse
                                  handleCheckboxChange(item.itemId);
                                }}
                                style={{
                                  padding: "4px 8px",
                                  backgroundColor: "rgb(177 93 198)",
                                  color: "white",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  border: "none",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                }}
                              >
                                Select
                              </button>
                            </div> */}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}


                                        {/* For normal orders (non-TABLE_DINE_IN) */}
                                        {/* {order.orderType !== "TABLE_DINE_IN" && ( */}
                                        <ul
                                            style={{
                                                listStyle: "none",
                                                padding: 0,
                                                marginLeft: "10px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {itemsList
                                                .filter((item) => item.status === "Okay") // ✅ only keep items with status "Okay"
                                                .map((item, idx) => (
                                                    <li
                                                        key={idx}
                                                        style={{
                                                            color: "#000",
                                                            fontSize: "20px",
                                                            marginBottom: "6px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "space-between",
                                                        }}
                                                        onClick={(e) => e.stopPropagation()} // prevent expanding/collapsing
                                                    >
                                                        <label
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "8px",
                                                            }}
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                checked={!!checkedItems[item.listId]}
                                                                onChange={() => handleCheckboxChange(item.listId)}
                                                            />
                                                            {item.dishName} × {item.quantity}

                                                            <button
                                                                onClick={() => handleCancelSingleOrder(item.listId)}
                                                                style={{
                                                                    padding: "4px 8px",
                                                                    backgroundColor: "rgb(220, 53, 69)", // red color
                                                                    color: "white",
                                                                    fontSize: "12px",
                                                                    fontWeight: "bold",
                                                                    border: "none",
                                                                    borderRadius: "5px",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                Cancel
                                                            </button>
                                                        </label>
                                                    </li>
                                                ))}
                                        </ul>
                                        {/* )} */}

                                    </div>
                                )}



                                {order.orderType === "TABLE_DINE_IN" && (
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            marginTop: "10px",
                                        }}
                                    >
                                        <button
                                            onClick={(e) => handleAcceptOrderrsss(e, order.cartId)}
                                            style={{
                                                padding: "8px",
                                                backgroundColor: "rgb(177 93 198)",
                                                color: "white",
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                                border: "none",
                                                borderRadius: "5px",
                                                cursor: "pointer",
                                            }}
                                        >
                                            Accept
                                        </button>
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleAcceptOrderrss(e, order.cartId); // ✅ using cartId instead of itemId
                                            }}
                                            style={{
                                                padding: "8px",
                                                backgroundColor: "rgb(177 93 198)",
                                                color: "white",
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                                border: "none",
                                                borderRadius: "5px",
                                                cursor: "pointer",
                                            }}
                                        >
                                            Decline
                                        </button>
                                    </div>
                                )}




                                {/* Buttons for non-TABLE_DINE_IN orders */}
                                {order.orderType !== "TABLE_DINE_IN" && (
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            marginTop: "10px",
                                        }}
                                    >
                                        <button
                                            onClick={(e) => handleAcceptOrderr(e, uniqueId)}
                                            style={{
                                                padding: "8px",
                                                backgroundColor: "rgb(177 93 198)",
                                                color: "white",
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                                border: "none",
                                                borderRadius: "5px",
                                                cursor: "pointer",
                                            }}
                                        >
                                            Accept
                                        </button>
                                        <button
                                            onClick={(e) => handleDeclineOrder(e, uniqueId)}
                                            style={{
                                                padding: "8px",
                                                backgroundColor: "rgb(177 93 198)",
                                                color: "white",
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                                border: "none",
                                                borderRadius: "5px",
                                                cursor: "pointer",
                                            }}
                                        >
                                            Decline
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>

        </div >

    );
};

export default Orders;

